var _defs, _use, _use2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPackageClosedinline = function SvgPackageClosedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "packageClosed_inline_svg__a",
    d: "M500 363c0 9-6 17-15 22L266 496c-5 3-10 4-16 4s-11-1-16-4L15 385c-9-5-15-13-15-22V138c0-10 6-18 15-22L234 5c5-3 10-5 16-5s11 2 16 5l219 111c9 4 15 12 15 22v225M250 54l-52 27 163 84 55-27-166-84M84 138l166 83 54-27-163-85-57 29M56 348l166 84V265L56 180v168m388-168l-166 85v167l166-84V180z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#packageClosed_inline_svg__a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "#000",
    strokeOpacity: 0,
    xlinkHref: "#packageClosed_inline_svg__a"
  })));
};

export default SvgPackageClosedinline;